import { Store, ActionTree, ActionContext } from 'vuex'
import { State } from './state'
import { UserService } from "@/services/user.service";
import { Success } from "@/services/responses/Success";
import { EventBus } from "@/pitprojekt/event-bus";
import _ from 'lodash'

export async function getAllSettings(store: ActionContext<State, any>) {
    EventBus.$emit('showFullScreenLoaderEvent');
    store.commit('gettingSettings');
    store.dispatch('getCurrentUser');
}

export async function getCurrentUser(store: ActionContext<State, any>) {

    try {
        const currentUser = await UserService.getCurrentUser();
        store.commit('currentUser', currentUser);
        Success.showSnackbar('Witaj '+currentUser.name+'!');

        if (store.getters.settingsComplete)
            store.commit('settingsComplete');

        return true
    }
    catch (error) {
        return false
    }
}

export function cleanSettings(store: ActionContext<State, any>) {
    store.commit('cleanSettings')
}

export function changeDateFrom(store: ActionContext<State, any>, date :string) {
    store.commit('changeDateFrom', date)
}

export function changeDateTo(store: ActionContext<State, any>, date :string) {
    store.commit('changeDateTo', date)
}

export function changeSelectedProducts(store: ActionContext<State, any>, selectedProducts :Array<number>) {
    store.commit('changeSelectedProducts', selectedProducts)
}

export function changeSelectedProduct(store: ActionContext<State, any>, selectedProduct :number) {
    store.commit('changeSelectedProduct', selectedProduct*1)
}

export function setDefaultSelectedProduct(store: ActionContext<State, any>) {
    let products :Array<number> = _.map(store.getters.currentUserProducts, 'id');
    store.commit('setDefaultSelectedProduct', products.slice(0,5));
}

export function changeLastYear(store: ActionContext<State, any>, lastYear :boolean) {
    store.commit('changeLastYear', lastYear)
}

export default <ActionTree<State, any>> {
    getCurrentUser, getAllSettings, cleanSettings, changeDateFrom, changeDateTo, changeSelectedProducts, changeSelectedProduct, setDefaultSelectedProduct, changeLastYear
}
